
/* -------------------------------------
    Filter
------------------------------------- */

$(document).ready(function() {

    /* Accommodation list filters */

    // Filter the location filter list based on the selected region
    $('ul#region-list a').click(function() {
        const filter = $(this).data('filter');
        $('ul#location-list').isotope({
            filter: filter === '*' ? '.null_region' : filter,
        });

        $('img.lazy').trigger('appear');

        // When a Region is selected, remove the current Location
        // filter
        filters.accommodation['accommodation-location'] = null;
        $('ul#location-list li').each(function() {
            $(this).removeClass('active');
        });
        $('div[data-filter-box="accommodation"]').isotope();
    });

    $('div#region-select select').change(function() {
        const region = $(this).val();

        // Filter Location select options based on optgroup
        $('#location-select select optgroup').each(function() {
            if ($(this).attr('label') !== region) {
                $(this).hide();
            } else {
                $(this).show();
            }
        });

        $('img.lazy').trigger('appear');

        // When a Region is selected, remove the current Location
        // filter
        filters.accommodation['accommodation-location'] = null;
        $('div#location-select select').val('*');
        $('div#location-select span.selectbox .selectboxInner').html('Show all');
    });

    // Filter-out all locations until a region is chosen
    $('ul#location-list').isotope({filter: '.none'});


    /* Generic filters */

    var current;
    var filters = {};

    /* onload */
    imagesLoaded('#filter img', function() {
        var elements = $('div[data-filter-box]');

        elements.each(function(_index) {
            var container = $(this).isotope({
                itemSelector: '.tile',
                layoutMode: 'fitRows',

                filter: function() {
                    var result = true;

                    // Check each filter group in the current filter
                    // box
                    for (group in filters[current]) {

                        var filter = filters[current][group];

                        if (group === 'query' && filters[current][group]) {
                            // Filter the item via the text in its H2
                            filter = function() {
                                var heading = $(this).find('h1,h2,h3,span,p,div');
                                if (heading.length === 0) {
                                    return false;
                                }
                                var item_text = heading.text() ? heading.text().toLowerCase() : null;
                                if (!item_text) {
                                    return true;
                                }
                                return item_text.indexOf(filters[current][group].toLowerCase()) > -1;
                            };
                        } else {
                            // Fetch filter function from the methods
                            // array or treat the filter as a jQuery
                            // selector (e.g. ".class-name")
                            filter = methods[filter] || filter;
                        }

                        // Update the overall result based on the
                        // filter for this item
                        if (filter) {
                            result = result && $(this).is(filter);
                        }

                        // Early return as soon as a filter returns
                        // false
                        if (!result) {
                            break;
                        }
                    }

                    /* final */
                    return result;
                }
            }).on('current', function(_e, box) {
                current = box;
            }).on('clear', function(_e, box) {
                filters[box] = {};
            }).on('reset', function() {
                filters = {};
            });

            var filterBox = $(this).data('filter-box');

            filterNav = $('nav.filter[data-filter-box="' + filterBox + '"] a');
            filterNav.click(function() {
                var parent = $(this).parents('ul');
                var box = parent.parent().data('filter-box');
                var group = parent.data('filter-group');
                var value = $(this).data('filter');

                parent.find('li').removeClass('active');
                $(this).parent().addClass('active');

                current = box;

                if (!filters[box]) filters[box] = {};
                filters[box][group] = value;

                container.isotope();

                /* lazyload */
                $('img.lazy').trigger('appear');
            });

            filterSel = $('nav.filter[data-filter-box="' + filterBox + '"] select');
            filterSel.change(function() {
                var parent = $(this).parents('div.input');
                var box = parent.parent().data('filter-box');
                var prefix = parent.data('class-prefix') || 'cat-';
                var group = parent.data('filter-group');
                var value = $(this).val();

                value = (value !== '*') ? `.${prefix}` + value : value;

                if ($(this).attr('name') == 'filter_price') {
                    value = $(this).val();
                }

                current = box;

                if (!filters[box]) filters[box] = {};
                filters[box][group] = value;

                container.isotope();

                /* lazyload */
                $('img.lazy').trigger('appear');
            });

            filterQuery = $('nav.filter[data-filter-box="' + filterBox + '"] input[data-filter-group="query"]');
            filterQuery.keyup(function() {
                var parent = $(this).parents('nav.filter');
                var box = parent.data('filter-box');
                var group = $(this).data('filter-group');
                var value = $(this).val();

                current = box;

                if (!filters[box]) {
                    filters[box] = {};
                }
                filters[box][group] = value;

                container.isotope();

                /* lazyload */
                $('img.lazy').trigger('appear');
            });

            /* Multi-select filter bars */
            filterCBs = $('nav.filter.multi-select[data-filter-box="' + filterBox + '"] input[type="checkbox"]');
            function _updateFilterCBClasses(cbs) {
                cbs.each(function() {
                    const that = this;
                    $(this).parents('nav.filter ul li').each(function() {
                        if ($(that).prop('checked')) {
                            $(this).addClass('active');
                        } else {
                            $(this).removeClass('active');
                        }
                    });
                });
            }
            function _getFilterCBValues(cbs, group) {
                return filterCBs
                      .filter(function() {
                          return $(this).parents('ul').data('filter-group') === group && $(this).prop('checked');
                      })
                      .map(function() {
                          return $(this).val();
                      })
                      .get()
                      .join(', ');
            }
            _updateFilterCBClasses(filterCBs);
            filterCBs.change(function() {
                const parent = $(this).parents('nav.filter');
                const box = parent.data('filter-box');
                const group = $(this).parents('nav.filter ul').data('filter-group');

                _updateFilterCBClasses(filterCBs);

                filters[box][group] = _getFilterCBValues(filterCBs, group);

                if (filters[box][group].length > 0) {
                    $(this).parent('label').parent('li').parent('ul').find('label.filter-cb-show-all').parent('li').removeClass('active');
                } else {
                    $(this).parent('label').parent('li').parent('ul').find('label.filter-cb-show-all').parent('li').addClass('active');
                }

                container.isotope();
            });

            // Multiselect "Show all" button
            $('nav.filter[data-filter-box="' + filterBox + '"] label.filter-cb-show-all').click(function() {
                const parent = $(this).parents('nav.filter');
                const box = parent.data('filter-box');
                const group = $(this).parents('nav.filter ul').data('filter-group');

                $(this).parent('li').parent('ul')
                    .find('input[type="checkbox"]')
                    .prop('checked', false);
                $(this).parent('li').addClass('active');
                _updateFilterCBClasses(filterCBs);
                filters[box][group] = _getFilterCBValues(filterCBs, group);
                container.isotope();
            })

            // Trigger a search query when the page loads
            setTimeout(function() {
                $('nav.filter[data-filter-box="' + filterBox + '"] input[data-filter-group="query"]').trigger('keyup');
            }, 500);
        });
    });

    /* methods */
    var methods = {

        /* <100 */
        l100: function() {
            var number = $(this).data('number');
            return (number <= 100);
        },

        /* >100 <150 */
        g100l150: function() {
            var number = $(this).data('number');
            return (number >= 100 && number <= 150);
        },

        /* >150 */
        g150: function() {
            var number = $(this).data('number');
            return (number >= 150);
        }
    };
});
